(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["setbox-dish-proof"] && !Shopify.designMode) return;
  try {
    
  /**
   * Photo toggle for the dish-proof carousel, ported from the canvas.
   *
   * The canvas keeps the index in React state and slides the outgoing photo
   * away in the direction of travel. Here the index lives on the element and
   * the direction is published as a custom property, so the transition stays
   * in CSS where the rest of the section's motion is.
   */
  class SetboxPhotoToggle extends HTMLElement {
    connectedCallback() {
      this.stack = this.querySelector('[data-stack]');
      if (!this.stack) return;

      this.index = 0;
      this.apply();

      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-step]');
        if (!button) return;
        this.move(Number(button.dataset.step) || 1);
      });

      this.listenForSwipe();
    }

    /**
     * Swipe on touch, since the arrows are a small target on a phone.
     *
     * Only horizontal movement counts, and only once it clearly beats the
     * vertical: a gesture that starts as a swipe but turns into a scroll has
     * to keep scrolling the page. That is also why nothing is ever
     * preventDefault()ed and the listeners are passive — taking the gesture
     * away from the scroller to animate a photo is the wrong trade.
     */
    listenForSwipe() {
      const THRESHOLD = 40;

      let startX = 0;
      let startY = 0;
      let tracking = false;

      this.stack.addEventListener(
        'touchstart',
        (event) => {
          if (event.touches.length !== 1) return;
          startX = event.touches[0].clientX;
          startY = event.touches[0].clientY;
          tracking = true;
        },
        { passive: true }
      );

      this.stack.addEventListener(
        'touchend',
        (event) => {
          if (!tracking) return;
          tracking = false;

          const touch = event.changedTouches[0];
          if (!touch) return;

          const dx = touch.clientX - startX;
          const dy = touch.clientY - startY;
          if (Math.abs(dx) < THRESHOLD || Math.abs(dx) <= Math.abs(dy)) return;

          // Swiping left pulls the next photo in from the right, which is the
          // same direction the arrow buttons travel.
          this.move(dx < 0 ? 1 : -1);
        },
        { passive: true }
      );

      this.stack.addEventListener('touchcancel', () => {
        tracking = false;
      }, { passive: true });
    }

    get slides() {
      return Array.from(this.stack.children);
    }

    move(step) {
      const total = this.slides.length;
      if (total < 2) return;
      this.style.setProperty('--setbox-dish-dir', step < 0 ? -1 : 1);
      this.index = (this.index + step + total) % total;
      this.apply();
    }

    apply() {
      this.slides.forEach((slide, i) => {
        const active = i === this.index;
        slide.toggleAttribute('data-active', active);
        // Keep the inactive photos out of the accessibility tree; they are the
        // same subject from another angle, not additional information.
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
    }
  }

  if (!customElements.get('setbox-photo-toggle')) {
    customElements.define('setbox-photo-toggle', SetboxPhotoToggle);
  }

  } catch(e) { console.error(e); }
})();
})();
